import React from 'react';
import Skeleton from './Skeleton';

export const ProfileSkeleton = () => (
  <div className="profile-container width-100p flex">
    <div className="height-300 width-300 radius-50p photo-container flex j-c-center a-i-center relative">
      <Skeleton variant="circular" width={300} height={300} />
    </div>
    <div className="grow-1 left-20" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Skeleton height={24} width="80%" />
      <Skeleton height={16} width="100%" />
      <Skeleton height={16} width="95%" />
      <Skeleton height={16} width="85%" />
    </div>
  </div>
);

export const BiographySkeleton = () => (
  <div className="biography">
    <h3 className="white"><Skeleton height={28} width={150} /></h3>
    <ul className="font-18" style={{ listStyle: 'none', paddingLeft: 0 }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <li key={i} style={{ display: 'flex', marginTop: '15px', alignItems: 'center', gap: '10px' }}>
          <div className="checked" style={{ flexShrink: 0 }}>
            <Skeleton width={30} height={30} />
          </div>
          <div style={{ flex: 1 }}>
            <Skeleton height={16} width="100%" />
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export const WorkSkeleton = () => (
  <div className="work">
    <h3 className="white"><Skeleton height={28} width={150} /></h3>
    <div className="width-100p flex work-container">
      <div className="light font-18 work-desc" style={{ flex: 1 }}>
        <Skeleton height={16} width="100%" count={4} />
      </div>
    </div>
  </div>
);

export const ContactSkeleton = () => (
  <div className="contact">
    <h3 className="white"><Skeleton height={28} width={150} /></h3>
    {Array.from({ length: 3 }).map((_, i) => (
      <p key={i} className="flex a-i-center font-18">
        <span className="contact-icon" style={{ flexShrink: 0 }}>
          <Skeleton variant="circular" width={40} height={40} />
        </span>
        <span className="light" style={{ marginLeft: '15px', flex: 1 }}>
          <Skeleton height={16} width="70%" />
        </span>
      </p>
    ))}
  </div>
);
